import { render, staticRenderFns } from "./VertexSearch.vue?vue&type=template&id=dfcd8b78&scoped=true&"
import script from "./VertexSearch.vue?vue&type=script&setup=true&lang=js&"
export * from "./VertexSearch.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfcd8b78",
  null
  
)

export default component.exports